var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"sb-capsule-text",style:({ background: _vm.bgColor, width: _vm.width })},[_vm._v(" "+_vm._s(_vm.emptyToLine(_vm.statusDesc))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }